import React from "react";
import "./AcInputText.css";
import { RemovePng } from "../../assets";

const RoInputText = ({
  type,
  name,
  placeholder,
  value,
  onChange,
  label,
  maxLength,
  disabled,
  error,
  onkeypress,
  id,
  defaultValue,
  onBlur,
  style,
  required,
  min,
  max,
}) => {
  return (
    <div className="ro-inputText-input-wrapper">
      <label className="ro-inputText-label" htmlFor={label}>
        {label}
      </label>
      <div className="ro-inputText-input-container">
        <input
          className="ro-inputText-input"
          type={type}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          onkeypress={onkeypress}
          id={id}
          defaultValue={defaultValue}
          onBlur={onBlur}
          style={style}
          required={required}
          min={min}
          max={max}
        />
      </div>
      {error ? (
        <div className="ro-inputText-error-container">
          <img
            className="inputText-img"
            style={{ verticalAlign: "middle" }}
            src={RemovePng}
            alt=""
          />
          <span>{error}</span>
        </div>
      ) : null}
    </div>
  );
};

export default RoInputText;
